<div class="toast-body">
  @if (toast.showIcon) {
    <span class="toast-icon" aria-hidden="true">{{ icon }}</span>
  }

  <div class="toast-content">
    @if (toast.title) {
      <p class="toast-title">{{ toast.title }}</p>
    }
    @if (toast.description) {
      <p class="toast-description">{{ toast.description }}</p>
    }
    @if (toast.referenceCode) {
      <p class="toast-reference">Código de referencia: <code class="toast-reference-code">{{ toast.referenceCode }}</code></p>
    }
  </div>

  <div class="toast-actions">
    @if (toast.actionLabel) {
      <button class="toast-action-btn" type="button" (click)="onAction()">
        {{ toast.actionLabel }}
      </button>
    }

    @if (toast.dismissible) {
      <button
        class="toast-dismiss-btn"
        type="button"
        aria-label="Cerrar notificación"
        (click)="onDismiss()"
      >
        ✕
      </button>
    }
  </div>
</div>
